import { Component, OnInit } from '@angular/core';
import { DoughnutChartHandler } from './doughnutChart.handler.';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-doughnut-chart',
  templateUrl: './doughnutChart.component.html',
  styleUrls: ['./doughnutChart.component.scss'],
})
export class DoughnutChartComponent extends DoughnutChartHandler implements OnInit {
  constructor(public service: DashboardService) {
    super(service);
  }
}
